import React, { forwardRef } from 'react';
import * as S from './styled';

const Frame = (props, ref) => (
  <S.StyledIframe {...props} ref={ref} height="100%" frameBorder="0" />
);

export default forwardRef(Frame);
